import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInvoiceThumbnail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 65,
	height: 80,
	viewBox: "0 0 65 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_6311_40911)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M56.1208 2.5H8.87838C7.56484 2.5 6.5 3.56296 6.5 4.87419V67.2259C6.5 68.5371 7.56484 69.6001 8.87838 69.6001H56.1208C57.4344 69.6001 58.4992 68.5371 58.4992 67.2259V4.87419C58.4992 3.56296 57.4344 2.5 56.1208 2.5Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M56.1206 2.64844H8.87817C7.64672 2.64844 6.64844 3.64496 6.64844 4.87424V67.2259C6.64844 68.4552 7.64672 69.4517 8.87817 69.4517H56.1206C57.3521 69.4517 58.3503 68.4552 58.3503 67.2259V4.87424C58.3503 3.64496 57.3521 2.64844 56.1206 2.64844Z",
				fill: "white",
				stroke: "#D0D5DD",
				strokeWidth: .5
			})]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.4727,
			y: 13.4102,
			width: 30,
			height: 1,
			rx: .5,
			fill: "#A9B4B9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.4727,
			y: 17.4102,
			width: 19,
			height: 1,
			rx: .5,
			fill: "#A9B4B9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.4727,
			y: 22.4102,
			width: 40,
			height: 3,
			rx: 1,
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.4727,
			y: 31.4102,
			width: 5,
			height: 20,
			rx: 1,
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 19.4727,
			y: 31.4102,
			width: 21,
			height: 20,
			rx: 1,
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 42.4727,
			y: 31.4102,
			width: 9,
			height: 20,
			rx: 1,
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.4727,
			y: 27.4102,
			width: 40,
			height: 1,
			rx: .5,
			fill: "#A9B4B9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.4727,
			y: 59.4102,
			width: 40,
			height: 1,
			rx: .5,
			fill: "#A9B4B9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.4727,
			y: 54.4102,
			width: 16,
			height: 1,
			rx: .5,
			fill: "#A9B4B9"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_6311_40911",
			x: .398438,
			y: .398438,
			width: 64.2019,
			height: 79.3032,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_6311_40911"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_6311_40911",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgInvoiceThumbnail;
